(function (app, ng) {
    app.component("transactionGroupForms",
        {
            controller: transactionGroupFormsController,
            templateUrl: "/App/Dashboard/ConfigureTransactionGroup/Forms/template.html",
            bindings: {
                transactionGroup: "<",
                onPublish: "&"
            }
        });

    transactionGroupFormsController.$inject = ["_", "$window", "$q", "$mdDialog", "figToaster", "figToastContainers", "fillableFormApi"];
    function transactionGroupFormsController(_, $window, $q, $mdDialog, figToaster, figToastContainers, fillableFormApi) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                addForms: addForms,
                removeForm: removeForm,
                updateForm: updateForm,
                viewPdf: viewPdf
            });

        this.$onInit = function () {
            fillableFormApi.getTransactionGroupForms($ctrl.transactionGroup.Id).then(function (response) {
                $ctrl.FillableForms = response;
            });
        };

        function addForms(files) {
            ng.forEach(files,
                function(file) {
                    var form = {
                        FileName: file.name,
                        IsValid: false,
                        IsOptional: false,
                        TransactionGroupId: $ctrl.transactionGroup.Id,
                        Title: "Form " + ($ctrl.FillableForms.length + 1)
                    }

                    var payload = new FormData();
                    payload.append("fillableForm", file, file.name);
                    payload.append("title", form.Title);

                    $ctrl.FillableForms.push(form);
                    fillableFormApi.add(form.TransactionGroupId, payload).then(function(response) {
                        form.Id = response.Id;
                        form.SubmittedById = response.SubmittedById;
                        form.SubmittedBy = response.SubmittedBy;
                        form.SubmittedOn = response.SubmittedOn;
                    });
                });
        }

        function removeForm(form, index) {
            figToaster.showYesNo("Are you sure you would like to delete " + form.Title + "?",
                "bottom center",
                figToastContainers.get("configure-transaction-group"),
                true).then(function(response) {
                if (!response) return;
                $ctrl.FillableForms.splice(index, 1);
                fillableFormApi.delete(form.Id);
            });
        }

        function updateForm(form) {
            fillableFormApi.update(form.Id, form);
        }

        function viewPdf(file) {
            if (file.Id) {
                fillableFormApi.get(file.Id).then(function(response) {
                    var url = URL.createObjectURL(response);

                    $window.open(url);
                });
            } else {
                var url = URL.createObjectURL(file.file);

                $window.open(url);
            }
        }
    };
})(window.app, window.angular); //jshint ignore:line